<template>
    <div class="edit">
        <div v-if="uploading" class="loader__box">
            <div class="loader__box__loader"></div>
            <h1 v-if="selected.new">Uw media wordt toegevoegd</h1>
            <h1 v-else>Uw media wordt aangepast</h1>
            <p>Een ogenblik geduld aub</p>
        </div>
        <div v-else class="edit__box">
          <div class="edit__box__titel">
              <h1 v-if="selected.titel != ''">{{ selected.titel }}</h1>
              <h1 v-else>Nieuwe media bestanden</h1>
              <p>Hier kan u de media bestanden toevoegen</p>
          </div>
          <div class="edit__box__project">
              <div class="edit__box__project__wrapper">
                  <div class="edit__box__form">
                      <div class="form_control">
                          <label for="">Type</label>
                          <select v-model="selected.intro">
                              <option disabled value="">Maak een keuze</option>
                              <option value="foto">Afbeelding</option>
                              <option value="video">Video</option>
  
                          </select>
                      </div>
                      <div class="form_control" v-if="selected.intro == 'video'">
                          <label>Titel</label>
                          <input v-model="selected.titel" placeholder="Titel">
                      </div>
                      <div class="form_control" v-if="selected.intro == 'video'">
                          <label>Video code</label>
                          <textarea cols="30" rows="10" v-model="selected.video" placeholder="Video code"></textarea>
                      </div>
                      <div class="file_input" v-if="selected.intro == 'foto'">
                          <div class="form_control">
                              <label for="e-afbeelding">Afbeeldingen</label>
                              <input type="file" id="e-afbeelding" name="e-afbeelding" @change="addExtra" multiple>
                          </div>
                      </div>                   
                    </div>
              </div>
              <div class="edit__box__input__extra__images">
                  <ProjectEditImage 
                      v-for="image in images"
                      :key="image"
                      :img="image.img"
                      :id="image.id"
                      @cancel_delete="removeDelete"
                      @start_delete="addDelete"
                  />
                  <ProjectLoadingImage 
                      v-for="image in imagesUploading"
                      :key="image"
                      :img="image.img"
                      :id="image.id"
                      :upload="image.upload"
                      @cancel_delete="removeDelete"
                      @start_delete="addDelete"
                  />
              </div>
              <div class="edit__box__input__buttons">
                  <p>{{ selected.edit }}</p>
                  <div class="edit__box__input__buttons__button">
                      <p class="button_2" @click="$emit('click_back')" v-if="selected.intro == 'video'">Terug</p>
                      <p class="button" @click="saveEdit" v-if="selected.intro == 'video'">Opslaan</p>
                      <p class="button" @click="$emit('click_save', 'new')" v-else>Klaar</p>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import ProjectEditImage from '../pages/_templates/ProjectEditImage.vue';
  import ProjectLoadingImage from '../pages/_templates/ProjectLoadingImage.vue';
  export default {
      props:["p_id"],
      inject:["data", "status"],
      components:{
          ProjectEditImage,
          ProjectLoadingImage
      },
      data(){
          return{
              p: this.$props.p_id,
              selected: {
                  new: false,
                  p_id: "",
                  titel: "",
                  gebouw: "",
                  locatie: "",
                  bouwjaar: "",
                  architect: "",
                  oppervlakte: "",
                  hero: "",
                  beschrijving: "",
                  img: "",
                  intro: "",
                  introImg: "",
                  introVideo: "",
                  edit: "",
                  video: ""
              },
              images:[],
              imagesUploading: [],
              uploadImg: false,
              uploadIntroVideo: false,
              uploadExtra: false,
              deleteImages: [],
              temp_id_img: 1,
              uploading: false,
          }
      },
      created(){
          if(this.p === ""){
              this.selected = {
                  new: true,
                  p_id: "",
                  titel: "",
                  gebouw: "",
                  locatie: "",
                  bouwjaar: "",
                  architect: "",
                  oppervlakte: "",
                  hero: "",
                  beschrijving: "",
                  img: "",
                  intro: "",
                  introImg: "",
                  introVideo: "",
                  edit: "",
                  video: ""
              }
          } else{
              this.getData();
          }
      },
      methods:{
        async addExtra(event){
            for(let i = 0; i < event.target.files.length; i++){
                this.imagesUploading.push({img: URL.createObjectURL(event.target.files[i]), temp_id: this.temp_id_img, upload: false})
                console.log(this.imagesUploading);
            }
            let data;
            for(let i = 0; i < this.imagesUploading.length; i++){
                if(this.imagesUploading[i].upload == false){
                    console.log(this.imagesUploading);
                    let date = new Date();
                    const months = ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"];
                    let editText = "Toegevoegd op " + date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear() + " om " + date.getHours() + ":" + date.getMinutes() + " door " + this.status.userName;
                    this.imagesUploading[i].upload = "pending";
                    await axios.post(this.status.api + '/post/upload-media.php', {
                        server: this.status.api,
                        userKey: this.status.userKey,
                        userMail: this.status.userMail,
                        userPass: this.status.userPass,
                        db: this.status.db,
                        id: this.selected.id,
                        upload: event.target.files[i],
                        edit: editText
                        }, {
                            headers: {'Content-Type': 'multipart/form-data'}
                        }).then(function (response) {
                        console.log(response);
                            if(response.status == 200){
                                data = true
                            }
                        }).catch(function (error) {
                            console.error(error);
                        }); 
                        if(data){
                            this.imagesUploading[i].upload = true;
                        }
                }
            }
        },
        async saveEdit(){
            this.uploading = true;
            let data;
            let date = new Date();
            const months = ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"];
            let editText = "Aangemaakt op " + date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear() + " om " + date.getHours() + ":" + date.getMinutes() + " door " + this.status.userName;
            await axios.post(this.status.api + '/post/new-media.php', {
                server: this.status.api,
                userKey: this.status.userKey,
                userMail: this.status.userMail,
                userPass: this.status.userPass,
                db: this.status.db,
                edit: editText,
                video: this.selected.video,
                alt: this.selected.titel
            }, {
                headers: {'Content-Type': 'multipart/form-data'}
            }).then(function (response) {
                if(response.status == 200){
                    data = true
                }
            }).catch(function (error) {
                console.error(error);
            }); 
            if(data){
                this.$emit('click_save', 'new');
            }
        }
      }
  }
  </script>